module.exports = __webpack_public_path__ + "media/images/flextab_devices-8b35b4d1d18f5c3a92333e65a44d3bb3.png";